const getCommaList = (list: string[] = [], finalDelimiter: string = 'and') =>
  list
    .join(', ')
    .replace(/(?:.(?!,\s))+$/, (match) =>
      match.replace(', ', ` ${finalDelimiter} `)
    );

export default getCommaList;
